// ModalContainer.js - Extracted all modal renderings from App.js
import React from 'react';
import { useModal } from '../contexts/ModalContext';
import { useForm } from '../contexts/FormContext';
import { useAuth } from '../contexts/AuthContext';
import { useNotification } from '../contexts/NotificationContext';
import MovieSearchModal from './MovieSearchModal';
import UPCScanner from './UPCScanner';
import MultiImageUpload from './MultiImageUpload';
import ProfileSetup from './ProfileSetup';
import ProfileCompletionModal from './ProfileCompletionModal';
// Removed unused supabase import and initialization - supabase is passed as prop

export const ModalContainer = ({
  supabaseUrl,
  supabaseAnonKey,
  supabase,
  handleMovieSearchSelect,
  handleUPCScanComplete,
  handleCloseWantedReleasesModal,
  userProfile,
}) => {
  const modal = useModal();
  const form = useForm();
  const { currentUser } = useAuth();
  const { showError } = useNotification();

  return (
    <>
      {/* Movie Search Modal */}
      {modal.isModalOpen('movieSearch') && (
        <MovieSearchModal
          isOpen={modal.isModalOpen('movieSearch')}
          onClose={() => {
            modal.closeModal('movieSearch');
            form.setBulkImportMovieTitle(''); // Clear search term when closing
          }}
          onMovieSelect={handleMovieSearchSelect}
          supabaseUrl={supabaseUrl}
          supabaseAnonKey={supabaseAnonKey}
          initialSearchTerm={
            modal.getModalProps('movieSearch')?.initialSearchTerm || form.bulkImportMovieTitle
          }
        />
      )}

      {/* UPC Scanner Modal */}
      {modal.isModalOpen('upcScanner') && (
        <UPCScanner
          onScanComplete={handleUPCScanComplete}
          onClose={() => modal.closeModal('upcScanner')}
          onOpenMovieSearch={() => {
            modal.closeModal('upcScanner');
            modal.openModal('movieSearch');
          }}
          supabaseUrl={supabaseUrl}
          supabaseAnonKey={supabaseAnonKey}
        />
      )}

      {/* Release Image Upload Modal */}
      {modal.isModalOpen('releaseImageUpload') && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-black border border-gray-600 rounded-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto dark-scrollbar">
            <h3 className="text-xl font-bold text-white mb-4">Upload VHS Box Photos</h3>
            <p className="text-gray-300 mb-4">
              Add multiple photos of your VHS box (front, back, spine, inside, etc.)
            </p>
            <p className="text-sm font-bold text-gray-300 mb-3">
              Only use original photos, or those unwatermarked from the public domain
            </p>

            <MultiImageUpload
              onImagesChange={(images, error) => {
                form.setSelectedReleaseImages(images);
                if (error) {
                  console.error('Release image error:', error);
                  showError('Image error: ' + error);
                }
              }}
              currentImages={form.selectedReleaseImages || []}
              error={null}
              maxImages={5}
            />

            <div className="flex justify-end space-x-3 mt-6">
              <button
                onClick={() => modal.closeModal('releaseImageUpload')}
                className="px-4 py-2 text-gray-600 hover:text-gray-800"
              >
                Cancel
              </button>
              <button
                onClick={() => {
                  modal.closeModal('releaseImageUpload');
                }}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700"
              >
                Use These Images
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Release Camera Modal - Placeholder for now */}
      {modal.isModalOpen('releaseCamera') && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-xl font-bold text-gray-900 mb-4">Take Photo</h3>
            <p className="text-gray-300 mb-4">Camera functionality coming soon!</p>
            <button
              onClick={() => modal.closeModal('releaseCamera')}
              className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* Profile Edit Modal */}
      {modal.isModalOpen('profileEdit') && currentUser && (
        <ProfileSetup
          currentUser={currentUser}
          userProfile={userProfile}
          supabase={supabase}
          onProfileCreated={() => {
            modal.closeModal('profileEdit');
            // Profile update handled by ProfileSetup
          }}
          onClose={() => modal.closeModal('profileEdit')}
          isEditing={true}
        />
      )}

      {/* Profile Completion Modal */}
      {modal.isModalOpen('profileCompletion') && currentUser && (
        <ProfileCompletionModal
          isOpen={modal.isModalOpen('profileCompletion')}
          onClose={() => modal.closeModal('profileCompletion')}
          currentUser={currentUser}
          supabase={supabase}
          onProfileCompleted={() => {
            modal.closeModal('profileCompletion');
          }}
        />
      )}
    </>
  );
};

export default ModalContainer;
